import styled, { css } from 'styled-components';

const BannerStyled = styled.div.attrs<{ showBanner: boolean }>({
  className: 'next-day-banner',
})`
  ${({ theme }) => {
    const { colors, media } = theme;

    return css`
      opacity: ${ props => props.showBanner ? 1 : 0 };
      transition: opacity 0.15s ease-in-out;
      pointer-events: ${ props => props.showBanner ? 'auto' : 'none' };
      display: flex;
      align-items: start;
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      padding: 16px 24px;
      z-index: 10;
      background-color: ${colors.primary.darkBlue};
      color: #fff;

      ${media.tablet.up} {
        background-color: ${colors.primary.whiteSmoke};
        padding: 20px 56px 20px 24px;
        color: ${colors.primary.darkBlue};
        margin-bottom: 80px;
        position: static;
        align-items: center;
        border-radius: 10px;
      }

      .next-day-banner {
        &__icon-wrapper {
          color: ${colors.primary.red};
          display: none;

          ${media.tablet.up} {
            display: block;
            margin-right: 15px;
          }
        }

        &__copy {
          font-size: 16px;
          line-height: 20px;
          font-weight: 500;
        }

        &__close {
          background: none;
          border: none;
          padding: 0 0 0 16px;

          svg {
            width: 24px;
            height: 24px;
          }

          ${media.tablet.up} {
            display: none;
          }
        }
      }
    `;
  }}
`;

export default BannerStyled;
